
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "commitHash": "5711569ffaf481d88ba3251343a1788090b35dd4",
    "version": "10.2.1"
};
/* tslint:enable */
